function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory, useLocation, useParams } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';
import { useMount, useSearchParam } from 'react-use';
import Page from '../components/page/Page';
import { getUserProfile } from '../redux/actions';
import routes from '../routes/constants';
import { larkiApi, larkiApiNoAuthentication } from '../utilities/api';
import { setUser } from '../utilities/storage';
var AcceptInvite = function() {
    var _location_state;
    var dispatch = useDispatch();
    var history = useHistory();
    var location = useLocation();
    var projectId = useParams().projectId;
    var token = useSearchParam('token');
    var userProfile = useSelector(function(state) {
        return state.profileReducer.userProfile;
    });
    if (!token && !((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.validated)) {
        return /*#__PURE__*/ React.createElement(Redirect, {
            to: routes.home
        });
    }
    var onAcceptInvite = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var _location_state, _location_state1, data, data1, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            8,
                            ,
                            9
                        ]);
                        if (!!((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.validated)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            larkiApiNoAuthentication.post('/user/verify-token', {
                                token: token
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        sessionStorage.clear();
                        setUser(data);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            larkiApi.put("/project/".concat(projectId, "/user"), {
                                inviteStatus: 'accepted'
                            })
                        ];
                    case 3:
                        data1 = _state.sent().data;
                        if (!((_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1.validated)) return [
                            3,
                            4
                        ];
                        history.push(routes.dashboard);
                        return [
                            3,
                            7
                        ];
                    case 4:
                        if (!isEmpty(userProfile)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            dispatch(getUserProfile())
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        history.push("".concat(routes.fileManager.root, "/").concat(data1.project));
                        _state.label = 7;
                    case 7:
                        return [
                            3,
                            9
                        ];
                    case 8:
                        e = _state.sent();
                        history.push(routes.login);
                        return [
                            3,
                            9
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function onAcceptInvite() {
            return _ref.apply(this, arguments);
        };
    }();
    useMount(function() {
        onAcceptInvite();
    });
    return /*#__PURE__*/ React.createElement(Page, {
        className: "PageCenter"
    }, /*#__PURE__*/ React.createElement(PulseLoader, {
        size: 12,
        color: "#31a283"
    }));
};
export default AcceptInvite;
